<template>
	<div :class="classNames">
		<div :class="classNames+'_con'">
			<div :class="classNames+'_con_table'">
				<el-table :data="tableListObj.data"
					:header-cell-style="{background: '#F5F7FA',color:'#454D53'}">
					<div slot="empty">
						<img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
					</div>
					<el-table-column :label="item.label" :prop="item.prop" v-for="(item, index) in headerData" :width="item.width" :key="index">
						<template slot-scope="scope">
							<div v-if="item.prop=='behavior'">提现</div>
							<div v-else-if="item.prop=='status_name'" v-amountStatusColor="scope.row.status" style="cursor:pointer" @click="handleClick(scope.row)">{{scope.row[item.prop]}}</div>
							<div v-else>{{scope.row[item.prop]}}</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<Pagination @change="changeSize" :total="tableListObj.total" ref="pagination" v-model="searchObj.page"  v-if="Math.ceil(tableListObj.total / searchObj.page_size) > 1"></Pagination>
			<withdrawal-res-dialog v-model="withdrawalResDialogFlag" :dataObj="dataAccountObj">
				<template slot="content">
					<steps :active="dataAccountObj.status == 1 ? 2:3">
						<step status="success">
							<span slot="title" style="color: #333">发起提现申请</span>
						</step>
						<step status="waiting">
							<div slot="title">
								<p style="color: #1677FF;">等待处理</p>
								<p style="font-size:14px;color: #999">预计3个工作日到账</p>
							</div>
						</step>
						<template v-if="dataAccountObj.status == 2">
							<step status="success">
								<span slot="title" style="color: #1677FF;">到账成功</span>
							</step>
						</template>
						<template v-else-if="dataAccountObj.status == 3 || dataAccountObj.status == 4">
							<step status="error">
								<div slot="title" style="color: #EA4B4B;">
									<p>到账失败</p>
									<p style="font-size:14px;">{{dataAccountObj.status_msg}}</p>
								</div>
							</step>
						</template>
						<template v-else>
							<step status="default">
								<span slot="title">到账成功</span>
							</step>
						</template>
					</steps>
           		</template>
			</withdrawal-res-dialog>
		</div>
	</div>
</template>

<script>
	import {
		mapActions
	} from 'vuex'
	import Pagination from '@/components/pagination/pagination.vue'
	import steps from '@/components/step/steps.vue'
	import step from '@/components/step/step.vue'
	import withdrawalResDialog from './withdrawalResDialog.vue'
	export default {
		name: 'withdrawalRecord',
		data() {
			return {
				classNames: 'withdrawalRecord',
                noDataName: 'empty',
				searchObj: {
					page: 1,
					page_size: 10
				},
                headerData: [
					{
						prop:'id',
						label: 'id',
						width: 90
					},
                    {
                        prop: 'trade_no',
                        label: '交易流水号'
				    },
                    {
                        prop: 'behavior',
                        label: '行为'
                    },
                    {
                        prop: 'amount',
                        label: '金额（元）'
                    },
                    {
                        prop: 'status_name',
                        label: '状态'
                    },
                    {
                        prop: 'create_time',
                        label: '时间'
                    }
                ],
                tableListObj: {},
				withdrawalResDialogFlag: false,
				dataAccountObj: {}
			}
		},
		created() {
			this.getapplyRecordList()
		},
		components: {
			Pagination,
			step,
			steps,
			'withdrawal-res-dialog': withdrawalResDialog
		},
		methods: {
			...mapActions('withdrawal', ['applyRecord']),
			async getapplyRecordList(flag) {
				if(flag) {
					this.searchObj.page = 1
				}
				let res = await this.applyRecord(this.searchObj)
                this.tableListObj = res
			},
			handleClick(row) {
				this.withdrawalResDialogFlag = true
				this.dataAccountObj = {
					amount: row.amount,
					account: row.account_name.account,
					status: row.status,
					status_msg: row.status_msg
				}
			},
			changeSize(size) {
				this.searchObj.page = size
				this.getapplyRecordList()
			}
			
		},
		 directives: {
			amountStatusColor: {
				bind(el, binding) {
					let objColor = {
						1: '#FFA555',
						2: '#2DC695',
						3: '#EA4B4B',
						4: '#EA4B4B'
					}
					let value = binding.value
					el.style.color = objColor[value]
				}
			}
		}
	}
</script>
<style lang="less">
	@classNames: withdrawalRecord;
	.@{classNames} {
		.el-table::before {
			background-color: transparent;
		}
		.el-table__header {
			width: 100%!important;
		}
		.el-table__body {
			width: 100%!important;
		}
	}
	.@{classNames}_con_table {
		.@{classNames}_empty {
			position: absolute;
			top: 0px;
			left: 0;
			width: 1000px;
			height:10px;
			background: #fff;
			z-index: 100;
		}
	}
</style>
<style lang='less' scoped>
	@classNames: withdrawalRecord;

	.@{classNames} {
		display: flex;
		flex-direction: column;
		height: 100%;
		/* overflow: hidden; */
		.@{classNames}_con {
			flex: 1;
			display: flex;
			flex-direction: column;
		}
	}
</style>
